const customeConsole = () => {
  const consoleHolder = window.console
  if (process.env.VUE_APP_CONSOLE === 'no') {
    window.console = {}
    console.log = function() {
    }
    console.error = function() {
    }
  } else {
    window.console = consoleHolder
  }
}

export default customeConsole
